import Papa from "papaparse";

export interface CsvColumnDef {
  key: string;
  header: string;
  example?: string;
}

export const parseCsv = (csv: string): Record<string, string>[] => {
  const result = Papa.parse<Record<string, string>>(csv, {
    header: true,
    skipEmptyLines: true,
    transformHeader: (h) => h.trim().toLowerCase(),
  });
  return result.data;
};

export const generateCsvTemplate = (columns: CsvColumnDef[]): string => {
  const fields = columns.map((c) => c.header);
  const exampleRow1 = Object.fromEntries(
    columns.map((c) => [c.header, c.example ?? ""]),
  );
  return Papa.unparse({ fields, data: [exampleRow1] });
};

export const downloadCsv = (csvString: string, filename: string): void => {
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
